module.exports = __webpack_public_path__ + "static/media/pinterest.64eab814.png";